import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { BannerComponent } from "./components/home/banner/banner.component";
import { TopOffersComponent } from "./components/home/top-offers/top-offers.component";
import { RelatedProductComponent } from "./components/home/related-product/related-product.component";
import { SubscribeComponent } from "./components/home/subscribe/subscribe.component";
import { TopSellingsComponent } from "./components/home/top-sellings/top-sellings.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { LoginComponent } from "./components/login/login.component";
import { SignupComponent } from "./components/signup/signup.component";
import { CorporateAdminComponent } from "./components/CorporateAdmin/corporateAdmin.component";
import { MyProfileComponent } from "./components/my-profile/my-profile.component";
import { ProductComponent } from "./components/product/product.component";
import { CategoryComponent } from "./components/category/category.component";
import { ProductAllComponent } from "./components/ProductAll/ProductAll.component";
import { OffersComponent } from "./components/offers/offers.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { CheckoutComponent } from "./components/checkout/checkout.component";
import { SuccessfulOrderComponent } from "./components/successful-order/successful-order.component";
import { appRoutes } from "./app-route";
import { AuthGuard } from "./app-route.guard";
import { NavBarComponent } from "./_shared/nav-bar/nav-bar.component";
import { HeaderComponent } from "./_shared/header/header.component";
import { FooterComponent } from "./_shared/footer/footer.component";
import { LoaderService } from "./_shared/services/loader.service";
import { AddToCartService } from "./_shared/services/add-to-cart.service";
import { CommonHttpService } from "./components/commonHttp.service";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ScrollableDirective } from "./scrollable.directive";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { OfferDetailComponent } from "./components/offer-detail/offer-detail.component";
import { CartComponent } from "./components/cart/cart.component";
import { OrdersComponent } from "./components/orders/orders.component";
import { OrderDetailComponent } from "./components/orders/order-detail/order-detail.component";
import { IssuesComponent } from "./components/orders/issues/issues.component";
import { StoreUserLoginComponent } from "./components/store-user-login/store-user-login.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { TopSellingProductsComponent } from "./components/top-selling-products/top-selling-products.component";
import { TopOfferProductsComponent } from "./components/top-offer-products/top-offer-products.component";
import { BrandDetailComponent } from "./components/brand-detail/brand-detail.component";
import { VerifyOtpComponent } from "./components/verify-otp/verify-otp.component";
import { AboutUsComponent } from "./components/additional-pages/about-us/about-us.component";
import { PrivacyPolicyComponent } from "./components/additional-pages/privacy-policy/privacy-policy.component";
import { ContactUsComponent } from "./components/additional-pages/contact-us/contact-us.component";
import { ExchangePolicyComponent } from "./components/additional-pages/exchange-policy/exchange-policy.component";
import { FaqComponent } from "./components/additional-pages/faq/faq.component";
import { ShippingPolicyComponent } from "./components/additional-pages/shipping-policy/shipping-policy.component";
import { TermsAndConditionsComponent } from "./components/additional-pages/terms-and-conditions/terms-and-conditions.component";
import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";
import { AccordionModule } from "ngx-accordion";
import { ClickOutsideModule } from "ng4-click-outside";
import { TermsComponent } from "./components/referral-terms/terms.component";
import { ReferralComponent } from "./components/referral/referral.component";
import { BannerProductAllComponent } from "./components/Banner-product-all/Banner-product-all.component";
import { DataDeletionComponent } from "./components/additional-pages/data-deletion/data-deletion.component";
let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(
      "326183710004-fkupjnh1eq9q56e0uh90laheael65maq.apps.googleusercontent.com"
    ),
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider("2114572818790260"),
  },
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    MyProfileComponent,
    ProductComponent,
    NotFoundComponent,
    NavBarComponent,
    HeaderComponent,
    FooterComponent,
    BannerComponent,
    TopOffersComponent,
    RelatedProductComponent,
    TopSellingsComponent,
    SignupComponent,
    CorporateAdminComponent,
    CategoryComponent,
    ProductAllComponent,
    ForgotPasswordComponent,
    OffersComponent,
    OfferDetailComponent,
    ScrollableDirective,
    CartComponent,
    OrdersComponent,
    OrderDetailComponent,
    IssuesComponent,
    StoreUserLoginComponent,
    SubscribeComponent,
    AboutUsComponent,
    PrivacyPolicyComponent,
    DataDeletionComponent,
    ContactUsComponent,
    ExchangePolicyComponent,
    FaqComponent,
    ShippingPolicyComponent,
    TermsAndConditionsComponent,
    CheckoutComponent,
    SuccessfulOrderComponent,
    ResetPasswordComponent,
    TopSellingProductsComponent,
    TopOfferProductsComponent,
    VerifyOtpComponent,
    BrandDetailComponent,
    TermsComponent,
    ReferralComponent,
    BannerProductAllComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    FormsModule,
    SocialLoginModule,
    AccordionModule,
    ClickOutsideModule,
    NgbModule.forRoot(),
  ],
  providers: [
    AuthGuard,
    LoaderService,
    CommonHttpService,
    AddToCartService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/app.module.ts